import { Button } from "@/src/components/buttons";
import { Card } from "@/src/components/cards";
import { openConfirmDialog } from "@/src/components/dialogs";
import { Consultation, Patient } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserShortName, isCabinet } from "@/src/utils/utils";
import moment from "moment";
import { openExistingIncomesList } from "../accounting/existingIncomesList";
import { openConsultationPage } from "../consultation/consultationPage";

function ConsultationCard({
  consultation,
  patient,
  onChange,
}: {
  consultation: Consultation;
  patient: Patient;
  onChange: (consultation: Consultation | null) => void;
}) {
  return (
    <Card
      title={"Consultation"}
      color="blue"
      onClick={async () => {
        await openConsultationPage({
          consultationId: getItemId(consultation),
          patient: patient,
          onSave: (consultation) => {
            onChange(consultation);
          },
        });
      }}
      onDelete={async () => {
        await openConfirmDialog({
          onConfirm: async () => {
            await apiFetch("general", "deleteAny", {
              id: getItemId(consultation),
              table: "consultations",
            });
            onChange(null);
          },
        });
      }}
      trailing={
        isCabinet() ? (
          <Button
            type="tertiary"
            onClick={async () => {
              await openExistingIncomesList({
                parentId: getItemId(consultation),
                patient: consultation.patient!,
                statuses: ["pending", "paid"],
              });
            }}
          >
            Encaisser
          </Button>
        ) : (
          <div></div>
        )
      }
    >
      {consultation.diagnostics?.length != 0 && (
        <div>
          {consultation.diagnostics?.map((refAnswer, index) => {
            return (
              <div key={refAnswer?.id} className="bold">
                {refAnswer?.reference?.name || ""}
              </div>
            );
          })}
        </div>
      )}
      {consultation.motives?.length != 0 && (
        <div>
          {consultation.motives?.map((refAnswer, index) => {
            return (
              <div key={refAnswer?.id}>
                <div className="bold">{refAnswer?.reference?.name || ""}</div>
                <div className="gray">{refAnswer?.notes || ""}</div>
              </div>
            );
          })}
        </div>
      )}

      <div className="bold">{consultation?.conclusion}</div>

      <div>{moment(consultation._date).format("LL à HH:mm")} </div>
      <div className="gray">
        {getUserShortName(consultation?.creator) || ""}
      </div>
    </Card>
  );
}

export default ConsultationCard;
